import { render, staticRenderFns } from "./chatMessages.vue?vue&type=template&id=722b8b0e&"
import script from "./chatMessages.vue?vue&type=script&lang=js&"
export * from "./chatMessages.vue?vue&type=script&lang=js&"
import style0 from "./chatMessages.vue?vue&type=style&index=0&id=722b8b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports